/**
 * @flow
 */
import React from "react"
import type { Node } from "react"
import styled from "styled-components"

type Props = {
  children: Node,
}

const Container = styled.div`
  h4 {
    font-size: 0.8rem;
    letter-spacing: 1px;
    padding: 0.25rem 0;
    line-height: 1.25rem;
    a {
      position: relative;
      display: inline-flex;
      overflow: hidden;
      &:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: rgba(255, 255, 255, 0.85);
        bottom: 0;
        left: 0;
        transition: 300ms ease-out;
      }
    }
  }
  @media (min-width: 768px) {
    h4 {
      padding: 0.25rem 0 0.25rem;
      a {
        &:hover {
          &:after {
            transform: translateX(101%);
          }
        }
      }
    }
  }
`

const Block = ({ children, ...props }: Props) => {
  return <Container {...props}>{children}</Container>
}

export default Block
